import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import {
  Spinner,
  Warning,
  TextArea,
  InfoDisplay
} from '../'

class ContactNotes extends React.Component {
  static propTypes = {
    contactId: PropTypes.string.isRequired,
    title: PropTypes.string,
    data: PropTypes.object.isRequired
  }

  static defaultProps = {
    title: 'Notes'
  }

  state = {
    editContactNotes: false,
    saveInProgress: false
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.data.contact) {
      this.setState({ contactNotes: props.data.contact.notes })
    }
  }

  goReadOnly = () => {
    this.setState({
      editContactNotes: false,
      saveInProgress: false
    })
  }

  noChangesToSave = () => (
    this.props.data.contact.notes === this.state.contactNotes
  )

  goEditNote = () => this.setState({ editContactNotes: true })

  handleNotesUpdate = () => {
    this.setState({ saveInProgress: true })

    let input = {
      id: this.props.data.contact.id,
      notes: this.state.contactNotes
    }

    if (!this.noChangesToSave()) {
      this.props.editContactNotes({ variables: { input } })
        .then(this.goReadOnly)
        .catch(() => this.setState({ saveInProgress: false }))
    } else {
      this.setState({ saveInProgress: false })
    }
  }

  render() {
    if (this.props.data.loading) {
      return <Spinner className='slds-is-relative' size='small' />
    }

    if (this.props.data.error) {
      return (
        <Warning>
          Failed to load contact notes.
        </Warning>
      )
    }

    const contact = this.props.data.contact

    return (
      <InfoDisplay
        title={
          <b>
            {this.props.title}
          </b>
        }
        rows={this.state.editContactNotes
          ? <TextArea
              value={this.state.contactNotes}
              onChange={e => this.setState({ contactNotes: e.target.value })}
            />
          : <tbody>
              <tr>
                <td>
                  {contact.notes || "none"}
                </td>
              </tr>
            </tbody>
        }
        edit={this.state.editContactNotes}
        onCancelClick={this.goReadOnly}
        onSaveClick={this.handleNotesUpdate}
        onEditClick={this.goEditNote}
        titleBold={false}
        saveDisabled={this.noChangesToSave() || this.state.saveInProgress}
        saveButtonLabel={this.state.saveInProgress ? 'Saving...' : null}
        className='slds-m-bottom_x-large'
      />
    )
  }
}

const getContactNotes = gql`query($id: ID!) {
    contact(id: $id) {
      id
      notes
    }
  }
`

const editContactNotes = gql`
  mutation editContactNotes($input: ContactMutationInput!) {
    contactMutate(input: $input) {
      contact {
        id
        notes
      }
    }
  }
`

const withData =
  graphql(getContactNotes, {
    options: ({ contactId }) => ({
      variables: {
        id: contactId
      }
    })
  })

const withContactMutate =
  graphql(editContactNotes, {
      name: 'editContactNotes'
    })

export default withData(withContactMutate(ContactNotes))



// WEBPACK FOOTER //
// ./src/components/contact-notes/index.js